import { createFileRoute, notFound } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

// Broken /services/ path redirects ported from src/App.tsx
const LEGACY_PATHS: Record<string, string> = {
  "commercial-lighting": "/energy-management/lighting-design",
  "led-retrofit": "/energy-management/lighting-retrofits",
  "commercial-electrical": "/electrical-services/commercial-electrical-contractor",
  "industrial-electrical": "/electrical-services/industrial-electrical-contractor",
  "hvac-repair-louisville-ky": "/hvac-services/hvac-service-repair",
  "electrician-louisville-ky": "/electrical-services",
  "residential-electrical": "/electrical-services",
  "smart-home-automation": "/electrical-services",
  "generators": "/electrical-services/generator-installation",
  "electrical-panels": "/electrical-services/electrical-panel-upgrades",
  "commercial-electrical-services": "/electrical-services",
  "commercial-hvac": "/hvac-services/commercial-hvac",
};

export const Route = createFileRoute("/services/$")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_PATHS[params._splat ?? ""];
    if (target) legacyRedirect(target);
    throw notFound();
  },
});
